export default __webpack_public_path__ + "static/media/268.c797b575.jpg";